document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-pdp-tabs]').forEach(function(group){
    var tabs=Array.from(group.querySelectorAll('[data-pdp-tab]'));
    var panels=Array.from(group.querySelectorAll('[data-pdp-panel]'));
    tabs.forEach(function(tab){
      tab.addEventListener('click',function(){
        var wasOpen=tab.getAttribute('aria-expanded')==='true';
        tabs.forEach(function(other){other.setAttribute('aria-expanded','false');other.classList.remove('is-active');});
        panels.forEach(function(panel){panel.hidden=true;});
        if(!wasOpen){
          tab.setAttribute('aria-expanded','true');
          tab.classList.add('is-active');
          var panel=group.querySelector('#'+tab.getAttribute('aria-controls'));
          if(panel)panel.hidden=false;
        }
      });
    });
  });
});